const newsletterSignup = () => {
    $('.js-footer-newsletter').on('submit', function(e) {
        e.preventDefault();

        const emailAddress = $(this).find('input[name="email"]').val();

        let tl;
        tl = gsap.timeline({
            onComplete: () => {
                $.ajax({
                    type: 'POST',
                    dataType: 'html',
                    url: scriptVars.ajaxUrl,
                    data: {
                        'email_address' : emailAddress,
                        'action': 'ajax_newsletter_signup'
                    },
                    success: function (data) {
                        const returnedData = JSON.parse(data);
                        
                        $('.footer__newsletter-form-message').text(returnedData.response);

                        let stl;
                        stl = gsap.timeline();
                        stl.to('.footer__newsletter-form-loader-container', {duration: 0.3, autoAlpha: 0});
                        stl.to('.footer__newsletter-form-message', {duration: 0.3, autoAlpha: 1, delay: 0.15});
                    },
                    error : function (jqXHR, textStatus, errorThrown) {
                        $(this).html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
                        console.log(jqXHR);
                    },
                });
            }            
        });
        tl.to('.js-footer-newsletter', {duration: 0.3, autoAlpha: 0});
        tl.to('.footer__newsletter-form-loader-container', {duration: 0.3, autoAlpha: 1}); 
    });
};